import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ currentPage = 1, totalPages = 10, onPageChange }) => {
  const DOTS = '...';
  
  const getPageNumbers = () => {
    const pageNumbers = [];
    
    if (totalPages <= 7) {
      // If total pages is 7 or less, show all pages
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Always show first page
      pageNumbers.push(1);
      
      if (currentPage <= 3) {
        // If current page is near the start
        pageNumbers.push(2, 3, 4, DOTS, totalPages);
      } else if (currentPage >= totalPages - 2) {
        // If current page is near the end
        pageNumbers.push(DOTS, totalPages - 3, totalPages - 2, totalPages - 1, totalPages);
      } else {
        // If current page is in the middle
        pageNumbers.push(DOTS, currentPage - 1, currentPage, currentPage + 1, DOTS, totalPages);
      }
    }
    
    return pageNumbers;
  };

  return (
    <div className="flex gap-1 items-center">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="p-2 text-[#013941] hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Previous page"
      >
        <ChevronLeft className="w-4 h-4" />
      </button>
      
      {getPageNumbers().map((pageNumber, index) => (
        <React.Fragment key={index}>
          {pageNumber === DOTS ? (
            <span className="px-3 py-2 text-gray-400">{DOTS}</span>
          ) : (
            <button
              onClick={() => onPageChange(pageNumber)}
              className={`px-3 py-1 rounded-lg min-w-[22px] font-semibold font-sans ${
                currentPage === pageNumber
                ? 'bg-[#013941] text-white'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
              aria-label={`Page ${pageNumber}`}
              aria-current={currentPage === pageNumber ? 'page' : undefined}
            >
              {pageNumber}
            </button>
          )}
        </React.Fragment>
      ))}
      
      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="p-2 text-gray-600 hover:text-gray-900 disabled:opacity-50 disabled:cursor-not-allowed"
        aria-label="Next page"
      >
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Pagination;